import { z } from "zod/v4";
import { PAYMENT_PROVIDERS } from "../payment/constants.js";
import { CreateCustomerInputSchema, CreateCustomerBackofficeInputSchema, } from "../customer/schemas/customer-schema.js";
export const MetaInputSchema = z.object({
    source: z.string(),
    company: z.string().optional(),
    gifts: z.string().optional(),
    initialSku: z.string().optional(),
    saltoContractId: z.string().optional(),
    saltoCreatedAt: z.string().optional(),
    campaignBooks: z.string().optional(),
    campaignSource: z.string().optional(),
    distributionMethod: z.string().optional(),
    distributionMedia: z.string().optional(),
    sendEmail: z.string().optional(),
    childName: z.string().optional(),
    childBirthDate: z.string().optional(),
});
export const CreateSubscriptionContractInputSchema = z.strictObject({
    customer: CreateCustomerInputSchema,
    paymentMethod: z.strictObject({
        identifier: z.union([
            z.literal(PAYMENT_PROVIDERS.INVOICE),
            z.literal(PAYMENT_PROVIDERS.NETS),
        ]),
        netsUnscheduledSubscriptionId: z.string().optional(),
    }),
    product: z.strictObject({
        sku: z.string(),
        planIdentifier: z.string(),
        name: z.string().nullable().optional(),
        subscriptionPlanPeriodId: z.string().optional().nullish(),
    }),
    freight: z.strictObject({ initialSku: z.string(), recurringSku: z.string() }),
    meta: MetaInputSchema,
    status: z
        .strictObject({
        renewAt: z.string().optional(),
        activeUntil: z.string().optional(),
    })
        .optional(),
});
export const CreateSubscriptionContractBackofficeInputSchema = CreateSubscriptionContractInputSchema.extend({
    customer: CreateCustomerBackofficeInputSchema,
});
